import { StorageManager } from 'src/app/common/storage-manager.class';
import { environment } from 'src/environments/environment';

export class TratamientosEnvironmentDefinition {

    public readonly rol: string = String(StorageManager.getUser()?.rol ?? '');
    public readonly appName: string = String(environment.appName ?? '');
    public readonly applicationType: string = String(environment.features.applicationType ?? '');
    public readonly serverUrl: string = String(environment.serverUrl ?? '');

    public readonly clienteName: string = String(environment.features.clienteName ?? 'Cliente');

    public readonly enableLegalMode: boolean = Boolean(environment.features.enableLegalMode);
    public readonly showUdsCuaderno: boolean = Boolean(environment.features.showUdsCuaderno);
    public readonly showTratamientosAllProductos: boolean = Boolean(environment.features.showTratamientosAllProductos);
    public readonly showTratamientosUnidades: boolean = Boolean(environment.features.showTratamientosUnidades);
    public readonly showUnidadesMedidaSIEX: boolean = Boolean(environment.features.showUnidadesMedidaSIEX);
    public readonly showTratamientosRecetaSwitch: boolean = Boolean(environment.features.showTratamientosRecetaSwitch);
    public readonly showAplicadoresActivo: boolean = Boolean(environment.features.showAplicadoresActivo);
    public readonly showTratamientosMenu: boolean = Boolean(environment.features.showTratamientosMenu);
    public readonly showTratamientosExportCsv: boolean = Boolean(environment.features.showTratamientosExportCsv);
    public readonly showTareasFitosanitarias: boolean = Boolean(environment.features.showTareasFitosanitarias);
    public readonly showTareasMto: boolean = Boolean(environment.features.showTareasMto);

    public readonly canAddTratamientos: boolean = Boolean(environment.features.canAddTratamientos);
    public readonly canDuplicateTratamientos: boolean = Boolean(environment.features.canDuplicateTratamientos);

    public readonly hasClients: boolean = Boolean(environment.features.hasClients);

    public readonly userCanSeeClientes: boolean = Boolean(
        environment.features.userCanSeeClientes
    ) || this.rol === 'admin';

    public get isPopup(): boolean {
        return window.name === '_blank, popup';
    }
}